export type StepType = "Échauffement" | "Corps de séance" | "Récupération" | "Répétition";
type UUID = string;
export type SportType = "cycling" | "swimming" | "running" | "chain" | "competition" | 'muscle' | 'repos' | 'ppg';
export type NoRestSportType = Exclude<SportType, "repos">;

const sportTranslations: Record<SportType, string> = {
  cycling: "Cyclisme",
  swimming: "Natation",
  running: "Course à pied",
  chain: "Enchaînement",
  competition: "Compétition",
  muscle: "PPG",
  ppg: 'PPG',
  repos: "repos"
};

const sportIcons: Record<SportType, string> = {
  cycling: "🚴",
  swimming: "🏊",
  running: "🏃",
  chain: "🔗",
  competition: "🏁",
  muscle: "🏋️",
  ppg: "🏋️",
  repos: "💤"
};

const workoutColors: Record<string, string> = {
  swimming: '#AEE2F3',
  running: '#AEE8B0',
  cycling: '#F2A5A5',
  muscle: '#D4B9EB',
  ppg: '#D4B9EB',
  competition: '',
  chain: '',
  rest: 'transparent',
};

export const translateSportType = (sport: SportType,) : string => {
  return sportTranslations[sport] || '';
};

export const getTranslation = (sport: SportType, name: string| null): string => {
  const prefix = translateSportType(sport);
  return `${prefix} ${name && name.length > 0 ? '|' : ''} ${name}`;
};

export const getIcon = (sport: SportType): string => sportIcons[sport] || '❓';

export const getWorkoutColor = (sport: SportType): string => workoutColors[sport] || 'gray.200'

export enum WeekDay {
  Lundi = 1,
  Mardi = 2,
  Mercredi = 3,
  Jeudi = 4,
  Vendredi = 5,
  Samedi = 6,
  Dimanche = 7
}

export interface Step {
  stepOrder: number;
  type: StepType;
  comment: string;
  durationType: "time" | "distance";
  durationValue: number; // in seconds for time or meters for distance
  intensity: "Repos" | "Zone 1" | "Zone 2" | "Zone 3" | "Zone 4" | "Zone 5" | "Zone 6" | "Zone 7";
  isRepeat: boolean;
  repeatCount?: number; // Only for repeatGroups
  steps?: Step[]; // Nested steps for repeat groups
  uuid: UUID;
}

export interface Workout {
  name: string;
  description: string;
  totalDuration: number;
  totalDistance: number;
  sportType: SportType;
  coachComment: string;
  nutritionComment: string;
  dayNumber: WeekDay;
  date_start?: string; // ISO date
  steps: Step[];
  uuid: UUID;
  isKeyWorkout: boolean;
  isSequence: boolean;
}

export interface Week {
  weekNumber: number;
  title?: string;  // Optional title
  coachComment: string;
  workouts: Workout[];
  uuid: UUID;
}

export interface TrainingPlan {
  planName: string;
  weeks: Week[];
  keywords: string[];
}

export interface TrainingPlanSchema {
  plan_id: string;
  content: TrainingPlan;
  keywords: string[]
}

export interface AllTrainingPlans {
  plan_id: string;
  planName: string;
  keywords: string[];
  weekCount: number;
}
